import { render, staticRenderFns } from "./ActionDialogue.vue?vue&type=template&id=090bcdec&scoped=true&"
import script from "./ActionDialogue.vue?vue&type=script&lang=js&"
export * from "./ActionDialogue.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/ActionDialogue.css?vue&type=style&index=0&id=090bcdec&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090bcdec",
  null
  
)

export default component.exports